import React, { useRef, useEffect } from 'react';
import { styled } from '@teko/ds-desktop';

const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
const StyledInput = styled.input`
  width: 42.5px;
  height: 42.5px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  outline: none;
  margin-top: 40px;
  margin-bottom: 25px;
  &:focus {
    border: 1px solid #eb1f3a;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const OptWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const OTPInput = ({
  className,
  onChange
}) => {
  const [otp, setOtp] = React.useState(["", "", "", "", "", ""]);
  const otpRefs = useRef();
  useEffect(() => {
    var _a;
    if ((_a = otpRefs.current) == null ? void 0 : _a[0])
      otpRefs.current[0].focus();
  }, []);
  useEffect(() => {
    if (onChange)
      onChange(otp.join(""));
  }, [JSON.stringify(otp)]);
  return /* @__PURE__ */ React.createElement(OptWrapper, {
    className
  }, otp.map((item, index) => /* @__PURE__ */ React.createElement(StyledInput, {
    type: "number",
    key: index,
    value: item,
    onChange: (e) => {
      var _a;
      const length = e.target.value.length;
      const value = e.target.value.slice(length - 1, length);
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index !== otp.length - 1)
        (_a = otpRefs.current) == null ? void 0 : _a[index + 1].focus();
    },
    ref: (e) => {
      if (!otpRefs.current)
        otpRefs.current = [];
      otpRefs.current[index] = e;
    },
    onKeyDown: (e) => {
      var _a, _b;
      const handleDelete = (e2) => {
        var _a2;
        e2.preventDefault();
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
        if (index !== 0)
          (_a2 = otpRefs.current) == null ? void 0 : _a2[index - 1].focus();
      };
      switch (e.keyCode) {
        case BACKSPACE:
        case DELETE:
          handleDelete(e);
          break;
        case LEFT_ARROW:
          if (index !== 0)
            (_a = otpRefs.current) == null ? void 0 : _a[index - 1].focus();
          break;
        case RIGHT_ARROW:
          if (index !== otp.length - 1)
            (_b = otpRefs.current) == null ? void 0 : _b[index + 1].focus();
          break;
      }
    }
  })));
};

export { OTPInput };
